import { render, staticRenderFns } from "./OperatingHours.vue?vue&type=template&id=158b2fc8&scoped=true&"
import script from "./OperatingHours.vue?vue&type=script&lang=ts&"
export * from "./OperatingHours.vue?vue&type=script&lang=ts&"
import style0 from "./OperatingHours.vue?vue&type=style&index=0&id=158b2fc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b2fc8",
  null
  
)

export default component.exports